import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useHistory } from 'react-router-dom';
import { DatePicker } from '../DatePicker/DatePicker';
import './SideBar.scss';
import logo from '../../images/logo.png';

const Sidebar = ({
  handleSideBarClick,
  calendarDay,
  handleDayClick,
  isSideBarVisible,
  isExporting,
  handleDownloadAllUnloggedUsers,
  handleMoveAllUsersToWhiteTick,
  showDatePicker,
  setShowDatePicker,
  selectedRange,
  setSelectedRange,
}) => {
  const { logout, currentUser } = useAuth();
  const history = useHistory();

  async function handleLogout() {
    try {
      await logout();
      history.push('/login');
    } catch {
      console.log('Failed to log out');
    }
  }
  return (
    <>
      <div className="side-bar">
        <button
          className="side-bar__button"
          onClick={() => handleSideBarClick()}
        />
        {isSideBarVisible && (
          <div className="side-bar__mobile">
            <img alt="digis-logo" src={logo} className="side-bar__logo" />
            <div>
              <DatePicker
                onDayClick={handleDayClick}
                selectedDays={calendarDay}
                className="side-bar__calendar"
              />
            </div>
            <a href="/" className="side-bar__link">
              Profile
            </a>
            <button className="side-bar__logout" onClick={handleLogout}>
              Logout
            </button>
          </div>
        )}
        <div className="side-bar__desktop">
          <img alt="digis-logo" src={logo} className="side-bar__logo" />
          <div>
            <DatePicker
              onDayClick={handleDayClick}
              selectedDays={calendarDay}
              className="side-bar__calendar"
            />
          </div>
          <div className="side-bar__buttons">
            <a href="/" className="side-bar__action">
              Profile
            </a>
            {currentUser && currentUser?.email === process.env.REACT_APP_KHARIN_EMAIL && (
              <button
                type="button"
                className="side-bar__action"
                onClick={() => setShowDatePicker(!showDatePicker)}
                data-for="export-all-unlogged"
                data-tip="Export logs"
              >
                Export Unfilled
              </button>
            )}
            {currentUser && currentUser?.email === process.env.REACT_APP_KHARIN_EMAIL && (
              <button
                type="button"
                className="side-bar__action"
                onClick={handleMoveAllUsersToWhiteTick}
                data-for="export-all-unlogged"
                data-tip="Export logs"
              >
                Move all entries
              </button>
            )}
            <button className="side-bar__logout" onClick={handleLogout}>
              Logout
            </button>
          </div>
        </div>
      </div>

      {showDatePicker && (
        <div className="side-bar__datePickerModal">
          <div className="side-bar__datePickerContent">
            <h3>Select Date Range</h3>
            <DatePicker
              selectedDays={
                selectedRange.from && selectedRange.to
                  ? [
                      selectedRange.from,
                      { from: selectedRange.from, to: selectedRange.to },
                    ]
                  : []
              }
              onDayClick={(day) => {
                if (
                  !selectedRange.from ||
                  (selectedRange.from && selectedRange.to)
                ) {
                  setSelectedRange({ from: day, to: undefined });
                } else {
                  setSelectedRange({ from: selectedRange.from, to: day });
                }
              }}
            />
            <div className="side-bar__datePickerActions">
              <button
                onClick={() => {
                  setShowDatePicker(false);
                  setSelectedRange({ from: undefined, to: undefined });
                }}
                className="side-bar__cancelButton"
              >
                Cancel
              </button>
              <button
                onClick={handleDownloadAllUnloggedUsers}
                disabled={!selectedRange.from || isExporting}
                className="side-bar__confirmButton"
              >
                {isExporting ? 'Exporting...' : 'Export'}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Sidebar;
